import React from 'react';
import RectangleSkeleton from 'components/Skeletons/RectangleSkeleton';
import BarChartSkeleton from 'components/Skeletons/BarChartSkeleton';
import styles from './PeakTimesWidget.module.css';

function PeakTimesSkeleton(): JSX.Element {
    return (
        <div className={styles.peakTimesSkeleton}>
            <div className={styles.peakTimesSummarySkeleton}>
                <RectangleSkeleton />
                <RectangleSkeleton />
            </div>
            <div className={styles.peakTimeSubtitleSkeleton}>
                <RectangleSkeleton />
            </div>
            <div className={styles.barChartSkeleton}>
                <BarChartSkeleton />
            </div>
            <div className={styles.peakTimeSubtitleSkeleton}>
                <RectangleSkeleton />
            </div>
            <div className={styles.barChartSkeleton}>
                <BarChartSkeleton />
            </div>
        </div>
    );
}

export default PeakTimesSkeleton;
